import { render, staticRenderFns } from "./TextInput.vue?vue&type=template&id=98897efa&scoped=true&"
import script from "./TextInput.vue?vue&type=script&lang=js&"
export * from "./TextInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98897efa",
  null
  
)

export default component.exports